import PropTypes from 'prop-types';

const ConfirmRemoveModal = ({ handleDeleteUser, handleCloseModal }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-xs sm:max-w-sm md:max-w-md mx-auto">
                <div className="p-4 sm:p-6">
                    <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-4 sm:mb-6">
                        Are you sure you want to delete this item?
                    </h3>
                    
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:justify-end">
                        <button 
                            className="w-full sm:w-auto px-4 py-2 text-sm sm:text-base font-medium text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors duration-200"
                            onClick={handleDeleteUser}
                        >
                            Yes, Delete
                        </button>
                        <button 
                            className="w-full sm:w-auto px-4 py-2 text-sm sm:text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                            onClick={handleCloseModal}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ConfirmRemoveModal.propTypes = {
    handleDeleteUser: PropTypes.func.isRequired,
    handleCloseModal: PropTypes.func.isRequired
};

export default ConfirmRemoveModal;